import React from 'react';
import { CustomToolbar } from 'utils/customToolBar';

import { styled } from '@mui/material/styles';
import { DataGrid, DataGridProps, gridClasses } from '@mui/x-data-grid';

// Define color constants
const COLORS = {
  LightYellow: '#FFF8E1',
  Black: '#000000',
  White: '#FFFFFF',
  LightBlue: '#E3F2FD',
  LightGray: '#F5F5F5',
};

// Styled DataGrid component
export const BaseStyledGrid = styled(DataGrid)<DataGridProps>(({ theme }) => ({
  border: 'none',
  backgroundColor: COLORS.LightYellow,
  fontSize: 14,
  fontWeight: 400,
  color: COLORS.Black,
  '.MuiDataGrid-toolbarContainer': { background: '#FFFBF1' },
  '.MuiDataGrid-columnHeaders': {
    marginBottom: 20,
    boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.16)',
  },
  '.MuiDataGrid-columnHeadersInner': { background: COLORS.White },
  '.MuiDataGrid-columnHeaderTitle': { fontWeight: 600 },
  '.MuiDataGrid-virtualScroller': {
    border: '1px solid rgb(224 224 224) !important',
  },
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: COLORS.White,
    '&:hover, &.Mui-hovered': { backgroundColor: COLORS.LightBlue },
  },
  [`& .${gridClasses.row}.odd`]: {
    backgroundColor: COLORS.LightGray,
    '&:hover, &.Mui-hovered': { backgroundColor: COLORS.LightBlue },
  },
  '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
  '&.MuiDataGrid-root .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 400,
    fontSize: '16px',
    color: '#000000',
    lineHeight: '24px',
  },
}));

export const StyledDataGrid = React.memo(function StyledDataGrid(props: DataGridProps) {
  const { slots, ...rest } = props;
  return <BaseStyledGrid slots={{ toolbar: CustomToolbar, ...(slots ?? {}) }} {...rest} />;
});
